import {Basic} from "./Basic";
import {Browser} from "./Browser";
import {Display} from "./Display";
import {Slider} from "./Slider";
import {Metrics} from "./Metrics";

window.addEventListener('DOMContentLoaded',async () =>
{
    // set variables
    Basic.init();

    // get environment
    Browser.analyze();
    Display.analyze();

    // get language from HTML
    Basic.lang = document.documentElement.lang;

    // remove hover class on mobile devices
    if(Browser.mobile === true)
    {
        document.body.classList.remove('w__hover');
    }

    // add event listeners
    Basic.add_changeEvent();
    Basic.add_clickEvent();

    // add slider
    const sliders = document.body.querySelectorAll('.w__tile--book-covers');
    sliders.forEach(el => {
        new Slider(el);
    });

    // listen for page unload
    add_visibilitychangeEvent();

    // start Metrics
    await Metrics.init();
});

// window resize detection
window.addEventListener('load',() =>
{
    if(!sessionStorage.getItem('hide-newsletter') &&
       !document.body.dataset.ise)
    {
        setTimeout(async () => {
            if(!sessionStorage.getItem('hide-newsletter') &&
               !document.body.querySelector('.w__modal'))
            {
                await Basic.build_newsletterModal(document.body);
            }
        },10 * 1000);
    }
});


// window resize detection
window.addEventListener('resize',() =>
{
    cancelAnimationFrame(Basic.resizeTimer);
    Basic.resizeTimer = requestAnimationFrame(Basic.process_resize);
});

// window resize detection
window.addEventListener('scroll',() =>
{
    cancelAnimationFrame(Basic.scrollTimer);
    Basic.scrollTimer = requestAnimationFrame(Basic.process_scroll);
});

const add_visibilitychangeEvent = () =>
{
    if(document.visibilityState)
    {
        document.addEventListener('visibilitychange',() =>
        {
            if(document.visibilityState === 'visible')
            {
                Metrics.reset();
            }
            else
            {
                Metrics.page_unload();
            }
        });
    }
    else
    {
        window.addEventListener('pagehide',() =>
        {
            Metrics.page_unload();
        });
    }
};